import { createValueFormatter } from '@cmg/data-grid';
import isEmpty from 'lodash/isEmpty';

import type {
  CalendarGridColDef,
  CalendarGridRowData,
  CalendarGridValueGetterFunc,
} from '../../CalendarGrid.model';

export type SellingRestrictions = '144A' | 'Reg S';

export type Value = SellingRestrictions[];

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data }) => {
  const sellingRestrictions: SellingRestrictions[] = [];

  if (data?.attributes?.isRegS) {
    sellingRestrictions.push('Reg S');
  }

  if (data?.attributes?.isRule144A) {
    sellingRestrictions.push('144A');
  }

  return sellingRestrictions;
};

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => {
    return !value || isEmpty(value) ? '-' : value.join(', ');
  },
});

const sellingRestrictionsColDef: CalendarGridColDef<Value> = {
  colId: 'sellingRestrictions',
  headerName: 'S/R ⓘ',
  headerTooltip: 'Selling Restrictions',
  width: 103,
  valueGetter,
  valueFormatter,
  filter: 'agSetColumnFilter',
};

export default sellingRestrictionsColDef;
